import { MyLink } from '../ui-kit';
import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './AlertInfo.module.scss';

export enum TypeAlertInfo {
  Info = 'info',
  Error = 'error',
  Success = 'success',
  Absent = 'absent',
}

type AlertInfoProps = {
  children: ReactNode;
  type?: TypeAlertInfo;
  link?: string;
  isHideArrow?: boolean;
  className?: string;
};

export const AlertInfo = ({ children, type = TypeAlertInfo.Info, className, link, isHideArrow }: AlertInfoProps) => {
  return (
    <div
      className={classNames(
        styles.Wrapper,
        styles[type],
        {
          [styles.hideArrow]: isHideArrow,
        },
        className,
      )}
    >
      {children}
      {link && (
        <MyLink className={styles.Link} href={link}>
          Узнать
        </MyLink>
      )}
    </div>
  );
};
